<template>
  <custom-tooltip :content='getServiceName'>
    <span :class="getIconStyle" slot='buttonContent'/>
  </custom-tooltip>
</template>

<script>
import { SERVICE_TYPES } from '@/constants/configuration';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'ServiceIcon',
  components: { CustomTooltip },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    getIconStyle() {
      if (SERVICE_TYPES[this.name]) {
        return `cloud-service-icon ${SERVICE_TYPES[this.name].icon}`;
      }
      return 'cloud-service-icon service-icon-unknown';
    },
    getServiceName() {
      if (SERVICE_TYPES[this.name]) {
        return SERVICE_TYPES[this.name].name;
      }
      return this.name;
    },
  },
};
</script>
